// Redesign interactions (scoped to .rd pages).
document.addEventListener('DOMContentLoaded', function () {
  Array.prototype.forEach.call(document.querySelectorAll('.rd [data-lab-videos]'), function (gallery) {
    var dialog = gallery.querySelector('[data-lab-dialog]');
    var player = gallery.querySelector('[data-lab-player]');
    var dialogTitle = gallery.querySelector('[data-lab-dialog-title]');
    var dialogText = gallery.querySelector('[data-lab-dialog-text]');
    var close = gallery.querySelector('[data-lab-close]');
    if (!dialog || !player) return;

    function stopVideo() {
      player.pause();
      player.removeAttribute('src');
      player.load();
    }

    function closeDialog() {
      stopVideo();
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }

    Array.prototype.forEach.call(gallery.querySelectorAll('[data-lab-video]'), function (button) {
      button.addEventListener('click', function () {
        var title = button.querySelector('[data-lab-video-title]');
        var text = button.querySelector('[data-lab-video-text]');
        player.src = button.getAttribute('data-video-src') || '';
        player.poster = button.getAttribute('data-video-poster') || '';
        if (dialogTitle) dialogTitle.textContent = title ? title.textContent : '';
        if (dialogText) dialogText.textContent = text ? text.textContent : '';
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        player.load();
        var playback = player.play();
        if (playback && typeof playback.catch === 'function') playback.catch(function () {});
      });
    });

    if (close) close.addEventListener('click', closeDialog);
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('close', stopVideo);
  });

  var reader = document.querySelector('.rd [data-reader]');
  if (!reader) return;

  var screens = Array.prototype.slice.call(reader.querySelectorAll('[data-slide]'));
  var texts = Array.prototype.slice.call(reader.querySelectorAll('.slide'));
  var count = Math.max(screens.length, texts.length);
  if (!count) return;
  var i = 0;
  reader.classList.add('is-enhanced');

  var dots = reader.querySelector('[data-dots]');
  var counter = reader.querySelector('[data-reader-count]');
  var cta = reader.querySelector('[data-reader-cta]');
  var status = reader.querySelector('[data-reader-status]');
  var dotLabel = reader.getAttribute('data-dot-label') || 'Show sample result {index}';
  if (dots) {
    for (var k = 0; k < count; k++) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'rdot' + (k === 0 ? ' on' : '');
      d.setAttribute('aria-label', dotLabel.replace('{index}', String(k + 1)));
      d.setAttribute('aria-current', k === 0 ? 'true' : 'false');
      d.dataset.readerIndex = String(k);
      d.addEventListener('click', function (event) {
        show(Number(event.currentTarget.dataset.readerIndex));
      });
      dots.appendChild(d);
    }
  }

  function show(n) {
    i = (n + count) % count;
    screens.forEach(function (s, k) {
      s.hidden = k !== i;
      s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
    });
    texts.forEach(function (t, k) {
      t.hidden = k !== i;
      t.setAttribute('aria-hidden', k === i ? 'false' : 'true');
    });
    if (dots) Array.prototype.forEach.call(dots.children, function (dot, k) {
      dot.className = 'rdot' + (k === i ? ' on' : '');
      dot.setAttribute('aria-current', k === i ? 'true' : 'false');
    });
    if (counter) counter.textContent = (i + 1) + ' / ' + count;
    if (status) {
      var heading = texts[i] && texts[i].querySelector('h3');
      status.textContent = (i + 1) + ' / ' + count + (heading ? ': ' + heading.textContent : '');
    }
    /* CTA stays visible on every slide: hiding it until the last slide
       lost users who never reached the end of the sample reader. */
    if (cta) cta.hidden = false;
  }
  show(0);

  var next = reader.querySelector('[data-next]');
  var prev = reader.querySelector('[data-prev]');
  if (next) next.addEventListener('click', function () { show(i + 1); });
  if (prev) prev.addEventListener('click', function () { show(i - 1); });
});
